export default __webpack_public_path__ + "static/media/pmd.bc0fbbd8.png";